import {cutHeadImg} from '@/common/util/global';
let mutations = {
    habitCommentNum(state, data) {
        state.commentDate = data.data; // 有老师评价的日期
    },
    updateCommentMutation(state, data) {
        state.commentDate = data; // 更新老师数组
    }
}
export default mutations;



// WEBPACK FOOTER //
// ./src/vuex/modules/habitJournal/mutations.js